import { CSSProperties } from 'outpost/preact';
import { BoardCard } from './board-card.ts';
import { BoardLocalData } from './board-local-data.ts';

export type BoardCardFrontComponentProps = {
    localData: BoardLocalData;
    card: BoardCard;
};

export function BoardCardFrontComponent(props: BoardCardFrontComponentProps) {
    let { localData, card } = props;
    let color = localData.getPlayerColor(card.ownerId);
    let style: CSSProperties = {
        boxSizing: 'border-box',
        border: `2px solid ${color}`,
        borderRadius: '7px',
        maxWidth: '100%',
        maxHeight: '100%',
        display: 'block',
        pointerEvents: 'none',
    };

    return <img
        style={style}
        src={localData.getImageSrc(card.cardId)}
    />
};